import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { submitContact } from "@/lib/api";

export const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitContact(form.name, form.email, form.message);
      toast.success("Message sent! Our team will get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error("Could not send your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 md:py-32 bg-obsidian">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-vitality">Get In Touch</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight mt-4 leading-tight">
            Questions? Talk To Us
          </h2>
        </div>

        <form onSubmit={onSubmit} data-testid="contact-form" className="glass rounded-2xl p-7 md:p-10 space-y-5">
          <div className="grid sm:grid-cols-2 gap-5">
            <input
              required
              value={form.name}
              onChange={update("name")}
              placeholder="Your name"
              data-testid="contact-name-input"
              className="bg-white/5 border border-white/15 rounded-xl px-5 py-3.5 text-white placeholder:text-white/40 focus:outline-none focus:border-vitality transition-colors"
            />
            <input
              required
              type="email"
              value={form.email}
              onChange={update("email")}
              placeholder="Email address"
              data-testid="contact-email-input"
              className="bg-white/5 border border-white/15 rounded-xl px-5 py-3.5 text-white placeholder:text-white/40 focus:outline-none focus:border-vitality transition-colors"
            />
          </div>
          <textarea
            required
            rows={4}
            value={form.message}
            onChange={update("message")}
            placeholder="How can we help?"
            data-testid="contact-message-input"
            className="w-full bg-white/5 border border-white/15 rounded-xl px-5 py-3.5 text-white placeholder:text-white/40 focus:outline-none focus:border-vitality transition-colors resize-none"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="contact-submit-button"
            className="inline-flex items-center justify-center gap-2 bg-vitality text-black font-bold uppercase tracking-wider text-sm px-7 py-3.5 rounded-xl hover:bg-vitality-dim transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Send Message <Send className="w-4 h-4" /></>}
          </button>
        </form>
      </div>
    </section>
  );
};
